import { render, staticRenderFns } from "./FileAttachments.vue?vue&type=template&id=4f48eda1&"
import script from "./FileAttachments.vue?vue&type=script&lang=js&"
export * from "./FileAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f48eda1')) {
      api.createRecord('4f48eda1', component.options)
    } else {
      api.reload('4f48eda1', component.options)
    }
    module.hot.accept("./FileAttachments.vue?vue&type=template&id=4f48eda1&", function () {
      api.rerender('4f48eda1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/files/FileAttachments.vue"
export default component.exports